import { render, staticRenderFns } from "./HrPerfPromiseTemplate.vue?vue&type=template&id=204f8500&scoped=true&"
import script from "./HrPerfPromiseTemplate.vue?vue&type=script&lang=js&"
export * from "./HrPerfPromiseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f8500",
  null
  
)

export default component.exports